<template>
  <div v-if="showMenu" class="side-menu">
    <el-menu :default-active="activePath" class="side-menu__menu" router>
      <el-menu-item v-for="route in routes" :key="route.path" :index="route.path">
        <i :class="getIcons(route.name)"></i>
        <span slot="title">{{ route.name }}</span>
      </el-menu-item>
    </el-menu>
  </div>
</template>

<script>
import router from '../routes'

export default {
  name: 'side-menu',
  props: {
    showMenu: {
      type: Boolean,
      default: true,
    },
  },
  data: function () {
    return {
      routes: router.options.routes.filter((e) => (e.meta != null ? e.meta.sidemenu : false)),
    }
  },
  computed: {
    activePath() {
      return this.$route.path
    },
  },
  methods: {
    getIcons(routeName) {
      switch (routeName) {
        case 'Dashboard':
          return 'el-icon-data-analysis'
        case 'Partners':
          return 'el-icon-user'
        case 'Connections':
          return 'el-icon-connection'
        case 'Certificates':
          return 'el-icon-tickets'
        case 'Messages':
          return 'el-icon-chat-dot-square'
        case 'Transactions':
          return 'el-icon-s-order'
        default:
          return 'el-icon-menu'
      }
    },
  },
}
</script>

<style scoped>
.side-menu {
  height: 100%;
  min-height: calc(100vh - 64px);
  padding: 12px 0 24px;
  background: #ffffff;
  color: #303133;
  border-right: 1px solid #ebeef5;
}

.side-menu__menu {
  border-right: none;
  background: transparent;
}

.side-menu__menu:not(.el-menu--collapse) {
  width: 100%;
}

.side-menu__menu :deep(.el-menu-item) {
  margin: 4px 12px;
  border-radius: 10px;
  color: #606266;
}

.side-menu__menu :deep(.el-menu-item i) {
  color: #909399;
}

.side-menu__menu :deep(.el-menu-item:hover) {
  background: rgba(254, 102, 0, 0.14);
  color: #303133;
}

.side-menu__menu :deep(.el-menu-item:hover i) {
  color: #fe6600;
}

.side-menu__menu :deep(.el-menu-item.is-active) {
  background: linear-gradient(135deg, #fe6600 0%, #e85e00 100%);
  color: #ffffff;
}

.side-menu__menu :deep(.el-menu-item.is-active i) {
  color: #ffffff;
}
</style>
